import {logUtishaDebug, logUtishaError} from '../../../util/log';

let SPEAKER_SELECTION_SUPPORTED = false;

export type SessionCapabilities = {
  isSupportMultipleVideos?: boolean
  supportsSharedArrayBuffer?: boolean
  maximumVideoStreams: number
  supportsSpeakerSelection?: boolean
}

export function getMaximumVideoStreams() {
  const maxDimension = Math.max(window.innerWidth, window.innerHeight);
  if (maxDimension <= 768) {
    return 4;
  }
  if (maxDimension <= 1024) {
    return 8;
  }
  if (maxDimension <= 1400) {
    return 12;
  }
  return 16;
}

async function checkSpeakerSelectionSupport(): Promise<boolean> {
  // First check if the browser supports mediaDevices API
  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    return false;
  }

  try {
    // Get all media devices
    const devices = await navigator.mediaDevices.enumerateDevices();

    // Filter to only include audio output devices
    const audioOutputDevices = devices.filter(
      device => device.kind === 'audiooutput'
    );

    // If we have more than one audio output device, speaker selection is supported
    return audioOutputDevices.length > 1;
  } catch (error) {
    logUtishaError('Error checking audio output devices:', error);
    return false;
  }
}

checkSpeakerSelectionSupport().then(result => {
  logUtishaDebug(`Speaker selection supported: ${result}`)
  SPEAKER_SELECTION_SUPPORTED = result;
})

export function getDefaultCapabilities(): SessionCapabilities {
  // https://developers.zoom.us/docs/video-sdk/web/video/
  return {
    supportsSpeakerSelection: SPEAKER_SELECTION_SUPPORTED,
    maximumVideoStreams: getMaximumVideoStreams(),
  };
}
